<template>
  <div class="page page-mask">
    <svg v-if="!isIE11" viewBox="0 0 1290 360" class="page-mask--back">
      <g transform="translate(-264 -30)">
        <path d="M263.5,189.08V23.775H1555c0,0,0.291,18.755,0,25.999
          c-0.13,3.229-0.869,13.808-1.125,15.876c-5.375,43.375-56.988,77.688-101.875,99.43c-64,31-401.951,68.875-618,65
          C611,226.08,263.5,189.08,263.5,189.08z"/>
        <path d="M263.5,211.08v186.225H1555c0,0,0.129-36.223,0.129-57.225c0-121.5-13.129-137.912-56.137-137.912c-75,0-295.07,40.805-466.01,48.163C690.333,265.08,263.5,211.08,263.5,211.08z"/>
      </g>
    </svg>
    <img v-else class="page-mask--back" src="/static/masks/mask-3.png"/>

  </div>
</template>

<script>
import IEDetector from '@/mixins/IEDetector';

export default {
  mixins: [IEDetector],
};
</script>



// WEBPACK FOOTER //
// src/components/Masks/Mask3.vue